<template>
  <div class="connect-wallet">
    <KeplrMessageBox />
    <MetamaskMessageBox />
    <WalletConnectMessageBox
      :qrImg="qrImg"
      :isQrImgLoading="isQrImgLoading"
      @refresh="onRefresh"
      :inviteAddress="ownerAddress"
    />
    <ConnectWalletMessageBox
      :inviteAddress="ownerAddress"
      @connectWallet="toConnectWallet"
    />

    <AcceptInvitationInformationMessageBox
      :showMessageBox.sync="isAcceptInvitationInformationMessageBox"
      :inviteAddress="getUser.address"
    ></AcceptInvitationInformationMessageBox>

    <AcceptInvitationMessageBox
      @confirm="toAcceptInvitation"
      :inviteAddress="ownerAddress"
      :showMessageBox.sync="isAcceptInvitationMessageBox"
    ></AcceptInvitationMessageBox>
    <AcknowledgementTermsMessageBox
      @iAgree="toiAgree"
      :showMessageBox.sync="isAcknowledgementTermsMessageBox"
    ></AcknowledgementTermsMessageBox>
    <ReferralRewardsMessageBox
      :showMessageBox.sync="isReferralRewardsMessageBox"
      :isfrom.sync="isReferralRewardsFrom"
      :referralRewardsInviteCode.sync="referralRewardsInviteCode"
    />
    <div class="login" v-if="getUser.address">
      <div class="login-info-box flex-align-center">
        <div class="info-img">
          <img :src="nftImg" alt="" @error="$st.handleImageError" />
        </div>
        <span>{{ $format.captureAddress(getUser.address) }}</span>
        <i class="icon icon-down-arrow"></i>
        <ul>
          <!-- <li @click="showReferralRewardsMessageBox">
            <i class="icon icon-Invitation-rebate"></i
            ><span>{{
              $t("layout.header.connectWallet.getReferralLink")
            }}</span>
          </li> -->
          <li v-clipboard:copy="getUser.address" v-clipboard:success="onCopy">
            <i class="icon icon-copy-user"></i
            ><span>{{ $t("layout.header.connectWallet.copyAddress") }}</span>
          </li>
          <li>
            <a
              class="a-link"
              :href="toViewOnStarScan()"
              target="_blank"
              rel="noopener noreferrer"
              ><i class="icon icon-starScan"></i
              ><span>{{
                $t("layout.header.connectWallet.viewOnStarScan")
              }}</span>
            </a>
          </li>
          <li @click="logoutConnectWallet">
            <i class="icon icon-sign-out"></i
            ><span>{{ $t("layout.header.connectWallet.disconnect") }}</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="no-login" v-else>
      <ButtonCommon
        @click="onOpenConnectWallet"
        type="marginXBridge"
        :width="'100%'"
        :height="'32px'"
      >
        <h6 class="h6-min">
          {{ $t("layout.header.connectWallet.connectWalletButText") }}
        </h6>
      </ButtonCommon>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations, mapActions, mapState } from "vuex";
import ButtonCommon from "@/components/Common/button";
import KeplrMessageBox from "@/components/Common/keplrMessageBox.vue";
import MetamaskMessageBox from "@/components/Common/metamaskMessageBox.vue";
import WalletConnectMessageBox from "@/components/Common/walletConnectMessageBox.vue";
import ConnectWalletMessageBox from "@/components/Common/connectWalletMessageBox.vue";
import AcceptInvitationMessageBox from "@/components/Home/walletConnect/acceptInvitationMessageBox";
import AcceptInvitationInformationMessageBox from "@/components/Home/walletConnect/acceptInvitationInformationMessageBox";
import AcknowledgementTermsMessageBox from "@/components/Home/walletConnect/acknowledgementTermsMessageBox";
import ReferralRewardsMessageBox from "@/components/Home/walletConnect/referralRewardsMessageBox.vue";
import api from "@/service/api";
import md5 from "js-md5";
export default {
  name: "connectWallet",
  data() {
    return {
      ownerAddress: "",
      inviteCode: "",
      referralRewardsInviteCode: "",
      isAcceptInvitationMessageBox: false,
      isAcknowledgementTermsMessageBox: false,
      isReferralRewardsMessageBox: false,
      isReferralRewardsFrom: false,
      isAcceptInvitationInformationMessageBox: false,
    };
  },
  components: {
    ButtonCommon,
    ConnectWalletMessageBox,
    AcceptInvitationMessageBox,
    AcceptInvitationInformationMessageBox,
    AcknowledgementTermsMessageBox,
    WalletConnectMessageBox,
    ReferralRewardsMessageBox,
    KeplrMessageBox,
    MetamaskMessageBox,
  },
  computed: {
    ...mapGetters(["getUser", "getWC", "getQueryPairInfo", "getConnectType"]),
    ...mapState({
      qrImg: (state) => state.connectWallet.qrImg,
      isQrImgLoading: (state) => state.connectWallet.isQrImgLoading,
      showMessageBox: (state) => state.connectWallet.showMessageBox,
      nftImg: (state) => state.nft.nftImg,
    }),
  },
  methods: {
    ...mapActions([
      "initConnect",
      "openConnectWallet",
      "getHighLevelNftDetail",
      "logoutConnectWallet",
    ]),
    ...mapMutations([
      "CHANGE_USER_INFO",
      "SAVE_WC",
      "GET_DATA_BASE_USER",
      "SET_QR_IMG",
      "SET_SHOW_MESSAGE_BOX",
      "SET_SHOW_WALLET_CONNECT",
      "SET_SHOW_KEPLR",
      "SET_CONNECT_TYPE",
      "SET_SHOW_METAMASK",
      "SET_SHOW_WALLET_CONNECT_V2",
      "SET_QR_IMG_LOADING",
    ]),

    async toConnectWallet(type) {
      console.log("toConnectWallet-type", type);

      if (!this.getUser.address) {
        this.SET_SHOW_MESSAGE_BOX(true);

        if (type === "walletconnect2" || type === "walletconnect") {
          this.SET_QR_IMG_LOADING(true);
          this.SET_SHOW_WALLET_CONNECT(true);
        } else if (type === "keplr") {
          this.SET_SHOW_KEPLR(true);
        } else if (type === "metamask") {
          this.SET_SHOW_METAMASK(true);
        }
      }

      await this.toInitConnect(type);
    },
    async showReferralRewardsMessageBox() {
      const findMyInviteCodeData = await api["findMyInviteCode"]({
        address: this.getUser.address,
      });

      if (findMyInviteCodeData.holdInviteCode) {
        this.referralRewardsInviteCode = findMyInviteCodeData.inviteCode;
        this.isReferralRewardsFrom = true;
      } else {
        this.isReferralRewardsFrom = false;
        this.referralRewardsInviteCode = "";
      }

      console.log("findMyInviteCodeData", findMyInviteCodeData);
      this.isReferralRewardsMessageBox = true;
    },

    async toAcceptInvitation() {
      this.isAcceptInvitationMessageBox = false;
      this.isAcceptInvitationInformationMessageBox = true;

      const params = {
        signer: this.getUser.address,
        message: { inviteCode: this.inviteCode },
      };
      console.log("toAcceptInvitation-params", params);
      try {
        const ordinarySignData = await this.getWC.ordinarySign(params);

        await this.createInviteRecord(
          ordinarySignData.signature,
          ordinarySignData.signed
        );

        console.log("ordinarySignData", ordinarySignData);
      } catch (error) {
        this.$notify({
          title: "Error",
          message: error,
          type: "error",
          showClose: true,
          duration: 5000,
        });
      } finally {
        this.isAcceptInvitationInformationMessageBox = false;
      }
    },
    async toiAgree() {
      this.isAcknowledgementTermsMessageBox = false;
      this.isAcceptInvitationMessageBox = true;
    },
    // copy the address
    onCopy(e) {
      this.$notify({
        title: this.$t("home.walletConnect.onCopy.title"),
        message: this.$t("home.walletConnect.onCopy.youJustMessage", {
          text: e.text,
        }),
        type: "success",
        showClose: true,
        duration: 5000,
      });
    },
    // refresh the QR codes
    async refreshConnect() {
      await this.toInitConnect(this.getWC._connector.connectType);
    },

    toViewOnStarScan() {
      const BROWSER =
        process.env.VUE_APP_BROWSER +
        `dex/address/${
          this.getUser.address
        }?chainId=MarginX-${this.$st.getPairBeforeVal(
          this.getQueryPairInfo.pair
        )}`;
      return BROWSER;
    },

    // exit close wallet
    // async logoutConnectWallet() {
    //   this.CHANGE_USER_INFO(null);
    //   this.SET_CONNECT_TYPE("");
    //   await this.getWC.disconnect();
    //   this.$notify({
    //     title: this.$t("home.walletConnect.disconnect.title"),
    //     message: this.$t("home.walletConnect.disconnect.message"),
    //     type: "error",
    //     showClose: true,
    //     duration: 5000,
    //   });
    // },

    async onRefresh() {
      await this.getWC.refreshHandler();
    },

    // create share information
    async createInviteRecord(signatureDetail, message) {
      const timestamp = Math.floor(new Date().getTime() / 1000);
      const signData = `J5XwZrT4hpwMvg+${this.ownerAddress}+${this.inviteCode}+${timestamp}`;
      const sign = md5(signData);
      const opt = {
        beInviteOwnerAddress: this.getUser.address,
        inviteCode: this.inviteCode,
        ownerAddress: this.ownerAddress,
        timestamp,
        signatureDetail: signatureDetail,
        message: message,
        signType: "personal_sign",
      };

      const createInviteRecordData = await api["createInviteRecord"](opt, {
        headers: {
          sign,
        },
      });

      if (createInviteRecordData.saveFlag) {
        this.isAcceptInvitationMessageBox = false;

        this.$notify({
          title: this.$t("home.walletConnect.createInviteRecord.successful"),
          message: this.$t(
            "home.walletConnect.createInviteRecord.theBindingIsSuccessful"
          ),
          type: "success",
          showClose: true,
          duration: 5000,
        });
      }

      createInviteRecordData.airDrop &&
        process.env.VUE_APP_REWARD_NNETWORK !== "prod" &&
        (await this.getTheAirdrop());
    },
    async getTheAirdrop() {
      try {
        await api["referralReward"]({
          address: this.getUser.address,
          network: process.env.VUE_APP_REWARD_NNETWORK,
          // captcha: recaptchaToken,
        });
      } catch (error) {
        console.error("getTheAirdrop-error", error);
      }
    },
    // get the address code
    async getQueryAddressByUserCode() {
      try {
        const queryAddressByUserCodeData = await api["queryAddressByUserCode"]({
          inviteCode: this.inviteCode,
        });
        console.log("queryAddressByUserCodeData", queryAddressByUserCodeData);
        this.ownerAddress = queryAddressByUserCodeData.ownerAddress;
      } catch (error) {
        console.error("getQueryAddressByUserCode-error", error);
      }
    },
    // Check if there is an invitation relationship between the two
    async getQueryInviteRelation() {
      try {
        const queryInviteRelationData = await api["queryInviteRelation"]({
          beInviteOwnerAddress: this.getUser.address,
          inviteCode: this.inviteCode,
        });
        console.log("queryInviteRelationData", queryInviteRelationData);

        if (
          this.inviteCode &&
          this.ownerAddress &&
          !queryInviteRelationData.existInvite
        ) {
          this.isAcknowledgementTermsMessageBox = true;
        }
      } catch (error) {
        console.error("getQueryInviteRelation-error", error);
      }
    },
    async toInitConnect(type) {
      console.log("toInitConnect", type);
      try {
        await this.initConnect({ connectType: type });

        this.$notify({
          title: this.$t("home.walletConnect.connectSuccessNotify.title"),
          message: this.$t("home.walletConnect.connectSuccessNotify.message"),
          type: "success",
          showClose: true,
          duration: 5000,
        });

        if (this.inviteCode && this.ownerAddress) {
          await this.getQueryInviteRelation();
        }

        // await this.getHighLevelNftDetail(this.getUser.address);
      } catch (error) {
        this.onRefresh();
        this.$notify({
          title: "Error",
          message: error,
          type: "error",
          showClose: true,
          duration: 5000,
        });
        throw error;
      }
    },
    isInviteCodeAndUserAddress() {
      const _inviteCode = this.$route.query.InviteCode;
      const _userAddress = this.getUser.address;
      return _inviteCode && _inviteCode !== "" && !_userAddress;
    },
    async onOpenConnectWallet() {
      if (this.isInviteCodeAndUserAddress()) {
        this.inviteCode = this.$route.query.InviteCode;
        await this.getQueryAddressByUserCode();
      }
      this.openConnectWallet();
    },
  },

  async mounted() {
    if (this.getConnectType && !this.getWC)
      this.toConnectWallet(this.getConnectType);

    // const _userAddress = this.getUser.address;
    // if (_userAddress) await this.getHighLevelNftDetail(_userAddress);
    this.$nextTick(() => {
      if (this.isInviteCodeAndUserAddress()) this.onOpenConnectWallet();
    });
  },
  // async created() {

  // },
};
</script>
<style lang="scss" scoped>
.connect-wallet {
  .login {
    .login-info-box {
      position: relative;
      background: #1e1f23;
      border-radius: 24px;
      cursor: pointer;

      &:hover {
        background: #2a2c32;
        &::before {
          content: "";
          position: absolute;
          width: 178px;
          height: 29px;
          top: 20px;
          right: -12px;
        }

        ul {
          display: block;
        }
      }

      ul {
        z-index: 999;
        display: none;
        font-style: normal;
        box-sizing: border-box;
        position: absolute;
        top: 40px;
        right: -24px;
        left: -24px;
        overflow: hidden;
        background: #2a2c32;
        border-radius: 12px;
        padding: 8px;
        box-sizing: border-box;
        box-shadow: rgb(0 0 0 / 30%) 0px 10px 20px,
          rgb(255 255 255 / 40%) 0px 0px 1px inset;

        li {
          position: relative;
          padding: 12px 16px;
          display: flex;
          align-items: center;
          border-radius: 8px;
          margin-bottom: 8px;

          &:last-child {
            margin-bottom: 0px;
          }
          a {
            display: flex;
            align-items: center;
            width: 100%;
            height: 100%;
            text-decoration: none;
          }
          .icon {
            opacity: 0.5;
            margin-right: 8px;
            pointer-events: none;
          }
          strong {
            pointer-events: none;
          }

          &:hover {
            transition: all $transition-all-time ease;
            background: #1e1f23;

            .icon {
              opacity: 1;
            }
          }
        }
      }

      .info-img {
        width: 28px;
        height: 28px;
        border: 1px solid #ffffff;
        border-radius: 50%;
        margin-right: 10px;
        overflow: hidden;

        img {
          width: 100%;
          transform: scale(1.2);
        }
      }
    }
  }
}
</style>
